import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Tool, ToolFormValues } from "@/types";
import { toast } from "sonner";

export const useToolActions = (refetch: () => void) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingTool, setEditingTool] = useState<Tool | null>(null);

  const handleDelete = async (id: string) => {
    try {
      setIsDeleting(true);
      const { error } = await supabase
        .from('tools')
        .delete()
        .eq('id', id);

      if (error) {
        console.error('Error deleting tool:', error);
        toast.error('حدث خطأ أثناء حذف الأداة');
        return;
      }

      toast.success('تم حذف الأداة بنجاح');
      refetch();
    } catch (error) {
      console.error('Error deleting tool:', error);
      toast.error('حدث خطأ أثناء حذف الأداة');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleSubmit = async (values: ToolFormValues) => {
    try {
      const toolData = {
        name: values.name,
        description: values.description,
        image_url: values.imageUrl,
        categories: values.categories,
        is_featured: values.is_featured,
        usage_guide: values.usage_guide || null,
        tutorial_video_url: values.tutorial_video_url || null,
        tool_url: values.tool_url || null,
        examples: values.examples || [],
      };

      console.log('Submitting tool data:', toolData); // Debug log

      if (editingTool) {
        const { error } = await supabase
          .from('tools')
          .update(toolData)
          .eq('id', editingTool.id);

        if (error) {
          console.error('Error updating tool:', error);
          toast.error('حدث خطأ أثناء تحديث الأداة');
          return;
        }
        toast.success('تم تحديث الأداة بنجاح');
      } else {
        const { error } = await supabase
          .from('tools')
          .insert([toolData]);

        if (error) {
          console.error('Error creating tool:', error);
          toast.error('حدث خطأ أثناء إضافة الأداة');
          return;
        }
        toast.success('تم إضافة الأداة بنجاح');
      }

      setIsDialogOpen(false);
      setEditingTool(null);
      refetch();
    } catch (error) {
      console.error('Error saving tool:', error);
      toast.error('حدث خطأ أثناء حفظ الأداة');
    }
  };

  const handleEdit = (tool: Tool) => {
    const transformedTool = {
      ...tool,
      tool_url: tool.tool_url || '',
    };
    setEditingTool(transformedTool);
    setIsDialogOpen(true);
  };

  return {
    isDeleting,
    isDialogOpen,
    setIsDialogOpen,
    editingTool,
    setEditingTool,
    handleDelete,
    handleSubmit,
    handleEdit,
  };
};